import React, { useState, useEffect } from 'react';
import { FaEye } from 'react-icons/fa';
import Modal from 'react-bootstrap/Modal';
import DataTable from 'react-data-table-component';
import { apiRequestHandler } from '../../apiConfig/service';
import { formatDate } from '../../utils/formatedDate';

const getAllTransections = async (endPoint, token) => {
  const res = await apiRequestHandler({
    endPoint,
    headers: { Authorization: `Bearer ${token}` },
  });
  return res?.data;
};

const TransactionsList = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [payments, setPayments] = useState([]);
  const [filteredPayments, setFilteredPayments] = useState([]);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);


  useEffect(() => {
    setIsLoading(true);
    getAllTransections('getAllTransectionData', localStorage.getItem('token'))
      .then((res) => setPayments(res || []))
      .finally(() => setIsLoading(false));
  }, []);

  useEffect(() => {
    const filtered =
      payments?.filter((payment) =>
        payment?.orderId?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        payment?.customerDetails?.customerName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        payment?.customerDetails?.customerEmail?.toLowerCase().includes(searchTerm.toLowerCase())
      ) || [];
    setFilteredPayments(filtered);
  }, [searchTerm, payments]);

  const handleViewClick = (payment) => {
    setSelectedPayment(payment);
    setShowViewModal(true);
  };

  const trimText = (text, maxLength = 50) => {
    if (!text) return 'N/A';
    return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
  };

  const serializeCartItems = (cartItems) => {
    if (!cartItems || cartItems.length === 0) return 'N/A';
    return cartItems.map(item => `${item.name} (Qty: ${item.quantity})`).join(', ');
  };

  const modalStyle = {
    label: {
      fontWeight: 600,
      fontSize: '14px',
      marginBottom: '8px',
      color: '#333',
    },
    value: {
      fontSize: '14px',
      color: '#555',
      marginBottom: '16px',
      wordBreak: 'break-word',
    },
  };

  const columns = [
    {
      name: 'Sr No.',
      selector: (row, index) => (currentPage - 1) * 10 + index + 1,
      width: '80px',
    },
    {
      name: 'Order ID',
      selector: (row) => trimText(row.orderId),
      sortable: true,
    },
    {
      name: 'Customer Name',
      selector: (row) => trimText(row.customerDetails?.customerName),
      sortable: true,
    },
    {
      name: 'Customer Email',
      selector: (row) => trimText(row.customerDetails?.customerEmail),
      sortable: true,
    },
    {
      name: 'Order Amount',
      selector: (row) => `${row.orderAmount} ${row.orderCurrency}`,
    },
    {
      name: 'Order Status',
      selector: (row) => row.orderStatus,
    },
    {
      name: 'Cart Items',
      selector: (row) => trimText(serializeCartItems(row.cartItems)),
    },
    {
      name: 'Created At',
      selector: (row) => formatDate(row.createdAt),
      sortable: true,
    },
    {
      name: 'Actions',
      cell: (row) => (
        <FaEye
          title="View"
          style={{ color: '#064a8c', cursor: 'pointer' }}
          onClick={() => handleViewClick(row)}
        />
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <div style={{ minHeight: '100vh', padding: '20px', background: '#f5f7fa' }}>
      <div style={{ backgroundColor: '#fff', padding: '20px', borderRadius: '10px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', marginBottom: '20px' }}>
          <h4 style={{ margin: 0 }}>Transactions List</h4>
        </div>
      </div>
      <br />
      <div className="modifyTable" style={{ borderRadius: '12px' }}>
        <DataTable
          title=""
          columns={columns}
          data={filteredPayments}
          pagination
          highlightOnHover
          onChangePage={setCurrentPage}
          paginationDefaultPage={currentPage}
          striped
          responsive
          progressPending={isLoading}
          subHeader
          subHeaderComponent={
            <input
              type="text"
              placeholder="Search by Order ID, Name or Email..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                padding: '8px 12px',
                borderRadius: '6px',
                border: '1px solid #ddd',
                fontSize: '14px',
                width: '300px',
              }}
            />
          }
        />
      </div>

      {/* View Modal */}
      <Modal show={showViewModal} onHide={() => setShowViewModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Transaction Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedPayment && (
            <div>
              <div><div style={modalStyle.label}>Order ID</div><div style={modalStyle.value}>{selectedPayment.orderId || 'N/A'}</div></div>
              <div><div style={modalStyle.label}>Order Amount</div><div style={modalStyle.value}>{selectedPayment.orderAmount} {selectedPayment.orderCurrency}</div></div>
              <div><div style={modalStyle.label}>Order Status</div><div style={modalStyle.value}>{selectedPayment.orderStatus}</div></div>
              <div><div style={modalStyle.label}>Customer Name</div><div style={modalStyle.value}>{selectedPayment.customerDetails?.customerName || 'N/A'}</div></div>
              <div><div style={modalStyle.label}>Customer Email</div><div style={modalStyle.value}>{selectedPayment.customerDetails?.customerEmail || 'N/A'}</div></div>
              <div><div style={modalStyle.label}>Customer Phone</div><div style={modalStyle.value}>{selectedPayment.customerDetails?.customerPhone || 'N/A'}</div></div>
              <div><div style={modalStyle.label}>Customer ID</div><div style={modalStyle.value}>{selectedPayment.customerDetails?.customerId || 'N/A'}</div></div>
              <div>
                <div style={modalStyle.label}>Cart Items</div>
                <div style={modalStyle.value}>
                  {selectedPayment.cartItems?.length > 0 ? (
                    <ul style={{ paddingLeft: '20px', margin: 0 }}>
                      {selectedPayment.cartItems.map((item, index) => (
                        <li key={index}>
                          {item.name} (Category: {item.category}, Price: {item.price}, Quantity: {item.quantity})
                        </li>
                      ))}
                    </ul>
                  ) : 'N/A'}
                </div>
              </div>
              <div><div style={modalStyle.label}>Verified</div><div style={modalStyle.value}>{selectedPayment.isVerified ? 'Yes' : 'No'}</div></div>
              <div><div style={modalStyle.label}>Created At</div><div style={modalStyle.value}>{formatDate(selectedPayment.createdAt)}</div></div>
              <div><div style={modalStyle.label}>Updated At</div><div style={modalStyle.value}>{formatDate(selectedPayment.updatedAt)}</div></div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            style={{
              background: '#00bfa5',
              color: '#fff',
              border: 'none',
              padding: '8px 16px',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '14px',
            }}
            onClick={() => setShowViewModal(false)}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default TransactionsList;
